module.exports = __webpack_public_path__ + "static/media/ehealth_pro_noti_center_p1_1.d7223253.png";